import React from 'react'
import moment from 'moment'
import { ExternalLink } from 'lucide-react'
import { cn } from '@/lib/utils'

export const CHANNELS = {
  email:    { label: 'Email',    classes: 'text-[#6366f1] bg-[#eef2ff]' },
  whatsapp: { label: 'WhatsApp', classes: 'text-[#22c55e] bg-[#f0fdf4]' },
  sms:      { label: 'SMS',      classes: 'text-[#f59e0b] bg-[#fffbeb]' },
  call:     { label: 'Call',     classes: 'text-[#0ea5e9] bg-[#f0f9ff]' }
}

const STATUS = {
  delivered: { label: 'Delivered',                          classes: 'text-[#22c55e] border-[#22c55e]' },
  opened:    { label: 'Opened',                             classes: 'text-[#6366f1] border-[#6366f1]' },
  processed: { label: 'Processed',                          classes: 'text-[#64748b] border-[#64748b]' },
  failed:    { label: 'Failed',                             classes: 'text-[#ef4444] border-[#ef4444]' },
  sending:   { label: 'Sending — check back in 15 minutes', classes: 'text-[#f59e0b] border-[#f59e0b]' },
  sent:      { label: 'Sent',                               classes: 'text-[#94a3b8] border-[#94a3b8]' }
}

function isTemporaryEmailFailure(msg) {
  return msg && (msg.startsWith('4') || msg.startsWith('Temporary'))
}

const EmailIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" fill="currentColor" viewBox="0 0 16 16">
    <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1zm13 2.383-4.708 2.825L15 11.105zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741M1 11.105l4.708-2.897L1 5.383z"/>
  </svg>
)

const WhatsAppIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" fill="currentColor" viewBox="0 0 16 16">
    <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232"/>
  </svg>
)

const SmsIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" fill="currentColor" viewBox="0 0 16 16">
    <path d="M5 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2"/>
    <path d="m2.165 15.803.02-.004c1.83-.363 2.948-.842 3.468-1.105A9 9 0 0 0 8 15c4.418 0 8-3.134 8-7s-3.582-7-8-7-8 3.134-8 7c0 1.76.743 3.37 1.97 4.6a10.4 10.4 0 0 1-.524 2.318l-.003.011a11 11 0 0 1-.244.637c-.079.186.074.394.273.362a22 22 0 0 0 .693-.125m.8-3.108a1 1 0 0 0-.287-.801C1.618 10.83 1 9.468 1 8c0-3.192 3.004-6 7-6s7 2.808 7 6-3.004 6-7 6a8 8 0 0 1-2.088-.272 1 1 0 0 0-.711.074c-.387.196-1.24.57-2.634.893a11 11 0 0 0 .398-2"/>
  </svg>
)

const CallIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" fill="currentColor" viewBox="0 0 16 16">
    <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z"/>
  </svg>
)

const CHANNEL_ICONS = { email: EmailIcon, whatsapp: WhatsAppIcon, sms: SmsIcon, call: CallIcon }

function formatCallDuration(seconds) {
  const s = parseInt(seconds, 10) || 0
  const m = Math.floor(s / 60)
  const r = s % 60
  return m > 0 ? `${m}m ${r}s` : `${r}s`
}

export function normalizeItem(item, type) {
  if (type === 'email') {
    return { ...item, _type: 'email', _sort_date: item.sent_at || item.delivered_at || item.failed_at }
  } else if (type === 'whatsapp') {
    return { ...item, _type: 'whatsapp', _sort_date: item.created_at }
  } else if (type === 'sms') {
    return { ...item, _type: 'sms', _sort_date: item.created_at }
  } else if (type === 'call') {
    return { ...item, _type: 'call', _sort_date: item.started_at }
  }
  return item
}

class MessageCard extends React.Component {
  constructor(props) {
    super(props)
    this.state = { expanded: false }
  }

  render() {
    const { item, isLast } = this.props
    const ch = CHANNELS[item._type]
    const Icon = CHANNEL_ICONS[item._type]

    let body = ''
    let subject = null
    let statusKey = null
    let via = null

    let statusTitle = null

    if (item._type === 'email') {
      subject = item.subject
      body = subject || ''
      via = item.service
      if (item.opened_at) statusKey = 'opened'
      else if (item.delivered_at) statusKey = 'delivered'
      else if (item.failed_at) {
        if (isTemporaryEmailFailure(item.failure_message)) {
          statusKey = 'sending'
        } else {
          statusKey = 'failed'
        }
        statusTitle = item.failure_message || 'Unspecified reason'
      }
      else statusKey = 'sent'
    } else if (item._type === 'whatsapp') {
      body = item.message_content || item.template_name || ''
      statusKey = item.message_status || 'sent'
    } else if (item._type === 'sms') {
      body = item.content || ''
      statusKey = item.workflow_state === 'processed' ? 'sent' : (item.workflow_state || 'sent')
    }

    const isCall = item._type === 'call'
    const isLong = body.length > 140
    const displayBody = isLong && !this.state.expanded ? body.slice(0, 140) + '...' : body
    const s = STATUS[statusKey] || STATUS.sent
    const m = item._sort_date ? moment(item._sort_date) : null
    const callRecordings = isCall ? (item.recordings || []).filter(r => r.playback_url) : []

    return (
      <div className={cn('rounded-[10px] border border-border bg-card px-4 py-3', !isLast && 'mb-2')}>
          <div className="mb-2 flex flex-wrap items-center justify-between gap-1.5">
            <div className="flex items-center gap-2">
              <span className={cn('inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-semibold uppercase tracking-[0.02em]', ch.classes)}>
                <Icon/> {ch.label}
              </span>
              {m &&
                <span className="text-[11px] font-medium text-muted-foreground">
                  {m.format('D MMM YYYY')} · {m.format('HH:mm')}
                </span>
              }
            </div>
            {isCall ?
              <span className="inline-flex items-center gap-1 text-[11px] font-medium text-muted-foreground">
                {item.direction === 'inbound' ? '↓ Inbound' : '↑ Outbound'}
                {item.duration ? ' · ' + formatCallDuration(item.duration) : ''}
              </span>
            :
              <span
                className={cn('inline-flex cursor-help items-center gap-1 text-[11px]', s.classes)}
                title={[statusTitle, via ? 'via ' + via : null].filter(Boolean).join(' — ') || undefined}
              >
                <span className="text-[8px]">●</span>
                <span className={cn('font-medium', statusTitle && 'border-b border-dotted')}>{s.label}</span>
                {item.opened_at && <span className="font-normal text-muted-foreground">at {moment(item.opened_at).format('HH:mm')}</span>}
              </span>
            }
          </div>

          {item._type === 'email' && subject &&
            <div className="mb-1 flex items-center font-semibold">
              <span className="flex-1">{subject}</span>
              {item.has_content &&
                <ExternalLink
                  onClick={() => this.props.onViewEmail && this.props.onViewEmail(item)}
                  className="ml-2 size-3 cursor-pointer text-muted-foreground"
                  title="View email content"
                />
              }
            </div>
          }

          {isCall &&
            <div>
              {callRecordings.length === 0 &&
                <div className="text-xs italic text-muted-foreground">No recording available</div>
              }
              {callRecordings.map((r) => (
                <audio
                  key={r.sid}
                  controls
                  preload="none"
                  src={r.playback_url}
                  className={cn('h-8 w-full', callRecordings.length > 1 && 'mt-1')}
                />
              ))}
            </div>
          }

          {(item._type !== 'email' && !isCall) &&
            <div className="text-foreground/80">
              {displayBody}
              {isLong &&
                <button
                  type="button"
                  onClick={() => this.setState({expanded: !this.state.expanded})}
                  className="cursor-pointer border-0 bg-transparent p-0 pl-1 text-[11px] font-semibold text-primary"
                >
                  {this.state.expanded ? 'Show less' : 'Read more'}
                </button>
              }
            </div>
          }
      </div>
    )
  }
}

export default MessageCard
